/* istanbul ignore file */
/*global YT */
// YT is a global from youTube's iframe.api
enum VideoAction {
  closeVideo = "close video",
  skipIntroVideo = "skipIntroVideo",
}

interface IMerapiVideoPlayer {
  playerName: string;
  thisVideoId: string;
  thisCallback: Function;
  callbackProps: object;
  closeButtonEl: HTMLElement;
}

export default class MerapiVideoPlayer {
  player: YT.Player;
  closeButton: any;
  clickHandler: Function;

  constructor(props: IMerapiVideoPlayer) {
    this.clickHandler = function (event: Event) {
      event.preventDefault();
      props.thisCallback(props.callbackProps);
      this.destroy();
    }.bind(this);

    this.closeButton = props.closeButtonEl;
    this.closeButton.addEventListener("click", this.clickHandler);

    this.player = this.createVideoPlayer(props);
  }

  private createVideoPlayer(props: IMerapiVideoPlayer) {
    return new YT.Player(props.playerName, {
      height: "390",
      width: "640",
      videoId: props.thisVideoId,
      playerVars: {
        modestbranding: 1,
        fs: 0,
        rel: 0,
        controls: 1,
        autoplay: 1,
      },
      events: {
        onStateChange: (ev: YT.OnStateChangeEvent) => {
          if (ev.data === 0) {
            props.thisCallback(props.callbackProps);
            this.destroy();
          }
        },
      },
    });
  }

  private destroy() {
    this.closeButton.removeEventListener("click", this.clickHandler);
    this.player.destroy();
  }
}

export { VideoAction };
